import React from 'react'
import { useTranslation } from 'react-i18next'
import PillButton from './PillButton'
import { cventConfig } from '../../config'

export function OnlineScheduleButton({ emphasis = 'medium' }) {
  const [t] = useTranslation()
  return (
    <PillButton to="/schedule" emphasis={emphasis} linkName="Heading: Online Schedule">
      {t('schedule.online.button', 'Online Schedule')}
    </PillButton>
  )
}

export function InPersonScheduleButton({ emphasis = 'medium' }) {
  const [t] = useTranslation()
  return (
    <PillButton
      to={cventConfig.scheduleUrl}
      emphasis={emphasis}
      noPrependLocaleCode
      external
      target="_blank"
      linkName="Heading: In-Person Schedule"
    >
      {t('schedule.in-person.button', 'In-Person Schedule')}
    </PillButton>
  )
}
